<template>
    <div id="toggleFixed">
        <b-card
            no-body 
            class="toggle-tab card_scroll overflow-hidden" 
            ref="cardScroll">  
            <!-- Lista de opciones -->
            <b-nav 
                id="toggleNav"
                pills 
                card-header 
                slot="header" 
                v-b-scrollspy:nav-scroller>
                <b-nav-item 
                    v-for="(item, indexI) in items"
                    @click="scrollIntoView"
                    :href="`#${item.path}`" 
                    :key="indexI">
                    {{ item.name }}
                </b-nav-item>
            </b-nav>
            <!-- end -->

            <b-card-body
                id="nav-scroller"
                ref="content"
                style="position:relative; height:600px; overflow-y:scroll;">
                <div 
                    class="mt-5 mb-5"
                    v-for="(item, indexTemplate) in items"
                    :key="indexTemplate">
                        <div :id="item.path">
                            <slot :name="item.path">
                            </slot>
                    </div>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
export default {
    props: {
        items: []
    },
    name: 'NavBarV2',
    created() {
        window.addEventListener('scroll', this.onScroll)
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
        onScroll () {
            const element = this.$refs.cardScroll
            const elementTop = element.getBoundingClientRect().top
            const elementChangeStyle = element.getElementsByClassName('card-header')[0].style
            const elementClass = element.getElementsByClassName('card-header')[0].classList
            if (window.scrollY >= (elementTop))  {
                this.applyStyles(elementChangeStyle, {
                    position: 'fixed',
                    top: '0',
                    'z-index': 15
                })
                elementClass.remove('col-12')
                elementClass.add('col-9')
            } else {
                this.applyStyles(elementChangeStyle, {
                    position: 'static'
                })
                elementClass.remove('col-9')
                elementClass.add('col-12')
            }
        },
        scrollIntoView(event) {
            event.preventDefault()
            const href = event.target.getAttribute('href')
            const el = href ? document.querySelector(href) : null
            if (el) { this.$refs.content.scrollTop = el.offsetTop }
        }
    }
}
</script>


<style lang="scss">
#toggleFixed {
    .card_scroll {
        border: 0;
        border-radius: 0;
    }
    .card_scroll .card-header {
        padding: 0;
        margin-bottom: 0;
        background-color: #FFFFFF;
        border-bottom: 0;
        display: block;
        text-align: center;
        border-radius: 48px;
    }
    #toggleNav {
        padding: 4px;
        /* CTA/00 */

        background: #FFFFFF;
        /* CTA/01 */

        border: 1px solid #C9CAFF;
        box-sizing: border-box;
        border-radius: 48px;

        /* Inside auto layout */

        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0.5px 0.5px;
        align-self: center;
        text-align:center;

        display:inline-block;
        *display:inline; /*IE7*/
        *zoom:1; /*IE7*/
        margin-right:10px;
        width: 100%;
        li {
            padding: 3px 12px;
            display:inline-block;
            a {
                font-family: 'Ubuntu';
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 22px;
                color: #000000;
            }
            a:hover, a.active {
                bottom: 0%;
                border-radius: 100px;
                flex-grow: 0;
                margin: 0px 1px;
                padding: 5px 10px;
                color: #FFFFFF;
                background-color: var(--main-primary-color);
            }
        }
    }
    .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
        color: #fff;
        background-color: var(--main-primary-color);;
    }
}

</style>